import { useQuery } from '@tanstack/react-query';

import { listAdmins, type ListAdminsParams } from '../../../api/admins';
import { useAuth } from '../../auth/AuthProvider';

export function useAdmins(params: ListAdminsParams = {}) {
  const { tokens } = useAuth();

  return useQuery({
    queryKey: ['admins', params],
    queryFn: () => listAdmins(params, tokens!.access_token),
    enabled: Boolean(tokens?.access_token),
  });
}
